import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Dropdown, Icon, IconButton } from 'components';
import styles from './DotsMenu.scss';

const DotsMenu = ({ actions, questionId }) => {
  const handleActionClick = (callback, close) => {
    callback(questionId);
    close();
  };

  return (
    <Dropdown
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      renderTrigger={({open, isOpen}) =>
        <IconButton
          onClick={open}
          className={
            classnames(
              styles.dotsMenu,
              { isOpen }
            )
          }
        >
          <Icon
            name='ion-md-more'
            horizontal
          />
        </IconButton>
      }
      renderContent={({close}) =>
        <div className={styles.container}>
          {
            actions.map(action =>
              <div
                key={action.type}
                onClick={() => handleActionClick(action.callback, close)}
                className={classnames(
                  styles.action,
                  {[styles.redFill]: action.type === 'remove'}
                )}
              >
                <Icon name={action.icon} />
                <span>{ action.label }</span>
              </div>
            )
          }
        </div>
      }
    />
  );
};

DotsMenu.propTypes = {
  actions: PropTypes.arrayOf(PropTypes.shape({
    type: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired,
    callback: PropTypes.func.isRequired
  })),
  questionId: PropTypes.string.isRequired,
};

DotsMenu.defaultProps = {
  actions: []
};

export default DotsMenu;
